import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scrollable-table"
// Shows the "swipe to see more" hint only when the table actually overflows
// its container, instead of guessing at a breakpoint.
export default class extends Controller {
  static targets = ["region", "hint"]

  connect() {
    this.boundCheckOverflow = this.checkOverflow.bind(this)

    this.checkOverflow()
    window.addEventListener("resize", this.boundCheckOverflow)
  }

  disconnect() {
    window.removeEventListener("resize", this.boundCheckOverflow)
  }

  checkOverflow() {
    const region = this.regionTarget
    const overflowing = region.scrollWidth > region.clientWidth

    this.hintTarget.classList.toggle("hidden", !overflowing)
  }
}
